/* "Sort" in the All … products bar (snippets/gh-sort.liquid): reorders the cards already on the page.
   Room pages and All products load every page into one list first (gh-collection), so the sort covers all.
   Featured puts back the page's own order: Featured products (picked in the editor) first. */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-gh-sort]');
    if (!sel) return;
    var root = sel.closest('#all-products') || document;
    var grid = root.querySelector('.gh-grid');
    if (!grid) return;
    var cells = Array.prototype.slice.call(grid.querySelectorAll(':scope > .gh-cell'));
    var n = 0;
    // numbered already (gh-collection sets the Featured order on load); a card added later goes last
    cells.forEach(function (c) { if (c.dataset.i === undefined) c.dataset.i = String(1e6 + n++); });
    // the first time, number the cards in the page's own order (featured first)
    if (!grid.dataset.ghNumbered) { cells.forEach(function (c, i) { c.dataset.i = String(i); }); grid.dataset.ghNumbered = '1'; }
    var by = {
      featured: function (a, b) { return +a.dataset.i - +b.dataset.i; },
      newest: function (a, b) { return (+b.dataset.date || 0) - (+a.dataset.date || 0) || +a.dataset.i - +b.dataset.i; },
      az: function (a, b) { return (a.dataset.title || '').localeCompare(b.dataset.title || ''); },
      za: function (a, b) { return (b.dataset.title || '').localeCompare(a.dataset.title || ''); }
    }[sel.value] || null;
    if (!by) return;
    var anchor = grid.querySelector(':scope > .gh-pagination');
    cells.sort(by).forEach(function (c) { grid.insertBefore(c, anchor); });
  });
})();
